import { create } from 'zustand';

export const useLayoutStore = create((set) => ({

    isCompactMode: false,

    setCompactMode: (isCompactMode) => {
        set({ isCompactMode });
    },

    toggleCompactMode: () => {
        set(state => ({
            isCompactMode: !state.isCompactMode
        }));
    }

}));